// extracted by mini-css-extract-plugin
export default {"button":"Button_button__e84dU","button__name":"Button_button__name__g+M9p"};